/**
 * Constructor.
 * Assigns data values and creates the DOM Node.
 * @param data any
 */
 var ColorSwatch = function(data) {
	//console.log(data,'data from color swatch.js');
	this.constants = window.PRESCRIPTION_CONSTANTS;

	this.key = data.key; // string
	this.label = data.label; // string
	this.contrastColorCode = data.contrast || 'grey'; // contrast color with fallback
	this.domHandle = null;
	this.displayRing = false;

	// color defaults
	//this.colorVars = '--swatch-color: black;';
	  this.colorVars = 'background-image: url()';
	this.verticalClass = '';

	// determine colors and mode
	if (data.code) {
		//this.colorVars = '--swatch-color: ' + data.code + ';';
		this.colorVars = 'background-image: url(' + 'https://cdn.shopify.com/s/files/1/0512/4741/5494/t/42/assets/' + data.key + '.png' +');';
	} else {
		if (data.start && data.end) {
			this.colorVars = '--swatch-start: ' + data.start + '; --swatch-end: ' + data.end + ';';
			this.verticalClass = 'color-swatch-js__ring--vertical';
		}
	}

	// finally create the fragment
	this.DOM = this.createDOM();
};

/**
 * Creates the DOM Node for the color swatch
 * @returns DOM Fragment
 */
ColorSwatch.prototype.createDOM = function() {
	/**
	 *  <div id="glass-color-template">
	 *    <label for="glass-color-input-">
	 *      <input type="radio" name="glass-color" id="glass-color-input-">
	 *      <span class="glass-color__text"></span>
	 *    </label>
	 *  </div>
	 */
	var commonKey = 'glass-color-input-' + this.key;
	var domString = [
		'<div id="'+this.key+'" class="color-swatch-js '+ this.key +'">',
		'   <label for="' + commonKey + '" class="color-swatch-js__label">',
		'     <input type="radio" name="glass-color" id="' + commonKey + '" class="color-swatch-js__radio">',
		'     <span class="color-swatch-js__label-text">' + this.label + '</span>',

		// pulsing ring, behind the other rings and only visible when active
		'     <div  class="color-swatch-js__ring color-swatch-js__ring--pulse ' + this.verticalClass + '"',
		'           style="' + this.colorVars + '">',
		'     </div>',

		// outer ring, which shows the color
		'     <div  class="color-swatch-js__ring color-swatch-js__ring--outer ' + this.verticalClass + '"',
		'           style="' + this.colorVars + '">',
		'     </div>',

		// inner ring, which is grey or the optional contrast color
		this.displayRing ? '     <div  class="color-swatch-js__ring color-swatch-js__ring--inner"' : '',
		this.displayRing ? '           style="--swatch-color: ' + this.contrastColorCode + ';">' : '',
		this.displayRing ? '     </div>' : '',
		'   </label>',
		'</div>',
	].join('');

	var fragment = document.createRange().createContextualFragment(domString);
	this.domHandle = fragment.firstChild;

	var input = fragment.querySelector('input');
	input.addEventListener('click', this.onClick.bind(this));

	return fragment;
};

/**
 * Disables the provided ColorSwatch
 * @param swatch ColorSwatch
 */
ColorSwatch.prototype.disableOne = function(swatch) {
	swatch.domHandle.classList.remove('active');
};

/**
 * EventHandler: Activates the color swatch when a user clicks it.
 */
ColorSwatch.prototype.onClick = function() {
	//console.log('clcik color');
	var selectedColorName = document.getElementById('glass-color__selected-color-name');
	selectedColorName.innerText = this.label;
	

	selectedColorName.classList +='-glass-color__selected-color-name-' +  this.label ;

	// turn off all other swatches
	this.disableAll();

	// turn on this swatch
	this.domHandle.classList.add('active');

	// save the selection in the cart form
	if (window.prescription) {
		var key = window.prescription.locale['lens_color'] || 'lens_color';
		window.prescription.setSelection(key, this.label);

		if (document.querySelector("#prescription-step-3") != null && window.innerWidth <= 768) {
			if (document.querySelector("#prescription-step-1") != null && !document.querySelector("#prescription-step-1").classList.contains("first-click")) {
				document.querySelector("#prescription-step-3").scrollIntoView();
			}
		}
	} else {
		console.warn('Storing Lens color failed, Prescription script is not loaded');
	}
};

/**
 * Fetches all JS Color Swatches from the Prescription UI and disables them all.
 * Does nothing if the prescription script is missing.
 */
ColorSwatch.prototype.disableAll = function() {
	if (window.prescription) {
		var allSwatches = window.prescription.getColorSwatches();
		allSwatches.forEach(this.disableOne);
	}
};
